import React from 'react';
import ReactDOM from 'react-dom';

const SERVICE_PAGE_NAVIGATION_ROOT_ID = 'service-page-navigation-root';

/**
 * Компонент корневого элемента для портала навигации Service Page
 * Этот элемент будет размещен в ServiceLayout и служит точкой назначения для портала
 */
export const ServicePageNavigationRoot = () => {
  return <div id={SERVICE_PAGE_NAVIGATION_ROOT_ID} />;
};

/**
 * Компонент портала для рендеринга элементов навигации Service Page
 * Позволяет рендерить компоненты из любого места иерархии в ServiceLayout
 */
interface ServicePageNavigationPortalProps {
  children: React.ReactNode;
}

export const ServicePageNavigationPortal: React.FC<ServicePageNavigationPortalProps> = ({
  children,
}) => {
  const [isClient, setIsClient] = React.useState(false);

  React.useEffect(() => {
    // Устанавливаем флаг клиента для предотвращения ошибок при SSR
    setIsClient(true);
  }, []);

  // В серверной среде или если элемент не найден, не рендерим ничего
  if (!isClient) {
    return null;
  }

  const navigationRoot = document.getElementById(
    SERVICE_PAGE_NAVIGATION_ROOT_ID
  );

  if (navigationRoot) {
    // Создаем портал для рендеринга children в целевой элемент
    return ReactDOM.createPortal(children, navigationRoot);
  }

  // Fallback - если элемент назначения не найден, не рендерим ничего
  return null;
};
